export const link_api =
  "https://alfacredenciamento.com/sistemas/checkinqrcode/api/";
